import { getMessages } from '../../../../store/constants';

export const MODAL_PROGRESS = getMessages().getText('timetracker.modal.progress');
